// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__qzvYa","label":"Category_label__FL6FZ","content":"Category_content__3xy24","header":"Category_header__1Vj2M","location":"Category_location__zUjQ7"};